import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../../../configs/firebase";
import { UploadFolder } from "../../../types/upload.types";

type ProgressCb = (pct: number) => void;
export async function uploadListingImagesToFirebase(
  files: File[],
  key: string,
  folder: UploadFolder,
  onProgress?: ProgressCb,
): Promise<string[]> {
  const cleanFiles = (files || []).filter(Boolean);
  if (!cleanFiles.length) return [];

  const uploads = cleanFiles.map(async (file, idx) => {
    const ext = file.name.split(".").pop() || "jpg";
    const path = `${folder}/${key}/${Date.now()}-${idx}.${ext}`;
    const storageRef = ref(storage, path);

    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  });

  return await Promise.all(uploads);
}
